module.exports = __webpack_public_path__ + "img/27.266da01a.jpg";